class CommonFunctions {
	static constants = {
		DEVELOPMENT: 'development',
		PREVIEW: 'preview',
		PRODUCTION: 'production',
		STAGING: 'staging',
		PERSONAL: 'personal',
		PRIORITY: 'priority',
		BUSINESS: 'business',
		CORPORATE: 'corporate',
		PRIVATE: 'private',
		COMMERCIAL: 'commercial',

		LANGUAGES: [ 'en', 'zh' ],

		ALLOWABLE_QUERYSTRING: [
			'subChanCode',
			'camp_id',
			'pid',
			'promoCode',
			'promo',
			'referId',
			'instance',
			'state',
			'utm_source',
			'utm_medium',
			'utm_campaign',
			'utm_term',
			'utm_content',
			'GiPrm',
			'productName',
			'truspleBuyerId',
		],
	};

	/**
	 * capture horizontal click position and return it's left or right
	 * @param {Number} xClick horizontal click position
	 * @return {String} return it's left or right
	 * @example
	 * getHorizontalPosition(1000)
	 */
	getHorizontalPosition( xClick ) {
		let width = Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		);
		let median = width / 2;
		return xClick < median ? 'left' : 'right';
	}

	/**
	 * calculate vertical position
	 * @param {Event} target event of the selector
	 * @return {String} return top, middle, bottom, persistent-bar, lightbox etc.
	 * @example
	 * calcElementLocation(event)
	 */
	calcElementLocation( target ) {
		if ( ! target ) return '';
		if ( target?.closest( '.c-modal' ) || target?.closest( '.sc-modal' ) ) {
			return 'lightbox';
		}

		if (
			typeof target.className === 'string' &&
			typeof target.className.includes !== 'undefined' &&
			( target.className.indexOf( 'sc-card-comparator__compare-btn' ) !== -1 ||
				target.className.indexOf( 'sc-card-comparator__card-remove' ) !== -1 )
		) {
			return 'bottom';
		}

		if (
			target?.closest( '.m-persistent-bar' ) ||
			target?.closest( '.sc-persistent-bar' ) ||
			target?.closest( '.m-persistent-bootom-bar' )
		) {
			return 'persistent-bar';
		}

		//Sorted array of positions
		let positions = [
			{
				name: 'top',
				depth: 30,
			},
			{
				name: 'middle',
				depth: 70,
			},
			{
				name: 'bottom',
				depth: 100,
			},
		];
		let maxHeight = Math.max( document.body.clientHeight, window.outerHeight );
		if ( maxHeight <= 0 ) {
			return '';
		}
		let scrollDepth = ( parseInt( this.getPosition( target ) ) * 100 ) / maxHeight;
		for ( let i = 0; i < positions.length; i++ ) {
			if ( scrollDepth < positions[ i ].depth ) {
				return positions[ i ].name;
			}
		}
		if (
			typeof target.parentNode.parentNode.className === 'string' &&
			typeof target.parentNode.parentNode.className.includes !== 'undefined' &&
			target.parentNode.parentNode.className.indexOf( 'sc-hdr__search' ) !== -1
		) {
			return 'top';
		}
		return 'bottom';
	}

	/**
	 * return absolute position of selected div in px
	 * @param {String} element class elements name as an object
	 * @return {Number} return horizontal position in px
	 * @example
	 * getPosition('.selector')
	 */
	getPosition( element ) {
		if ( ! element ) return '';
		let yPosition = 0;
		while ( element ) {
			yPosition += element.offsetTop - element.scrollTop + element.clientTop;
			element = element.offsetParent;
		}
		return yPosition;
	}

	/**
	 * return URL attributes
	 * @param {String} URL of the elements
	 * @return {Object} return href, protocol, hostname etc base on URL
	 * @example
	 * parseUrl('https://www.sc.com/sg/save/current-accounts/bonussaver/')
	 */
	parseUrl( url ) {
		var parser = document.createElement( 'a' );
		parser.href = url;
		if ( parser.protocol !== 'mailto:' ) {
			var link_path = parser.pathname.charAt( 0 ) === '/' ? parser.pathname : '/' + parser.pathname;
		} else {
			link_path = parser.pathname;
		}
		return {
			href: parser.href,
			protocal: parser.protocol,
			hostname: parser.hostname,
			port: parser.port,
			pathname: parser.hash.indexOf( '?' ) !== -1 ? link_path + parser.hash : link_path,
			rawpath: link_path,
			query: parser.query || parser.search,
			search: parser.query || parser.search,
			hash: parser.hash,
			host: parser.host,
		};
	}

	/**
	 * return URL attributes
	 * @param {String} URL of the elements
	 * @return {Object} return href, protocol, hostname etc base on URL
	 * @example
	 * currentURL('https://www.sc.com/sg/save/current-accounts/bonussaver/')
	 */
	urlBreakdown( currentURL ) {
		let that = this;
		var parser = that.parseUrl( currentURL );
		var queryString = parser.search,
			parts = parser.pathname.split( '/' ),
			hash = parser.hash,
			countryMapping = {
				sgbeta: 'sg',
			};
		if ( queryString && queryString.indexOf( '?' ) === 0 ) {
			queryString = queryString.slice( 1 );
		}
		var pageURL = {
			domain: null,
			country: null,
			language: null,
			category: null,
			segment: 'personal',
			subcategory: null,
			slug: null,
			queryString: queryString,
			hash: null,
			pathname: document.location.pathname,
		};

		pageURL.domain = parser.hostname;
		pageURL.country = parts[ 1 ];
		pageURL.language = 'en';

		if ( pageURL.country === 'cn' ) {
			pageURL.language = 'zh';
		}

		if ( parts[ 2 ] ) {
			pageURL.category = parts[ 2 ];
			if ( parts[ 2 ].length === 2 ) {
				pageURL.language = parts[ 2 ];
				pageURL.category = parts[ 3 ];
			}
		}

		if ( parts[ parts.length - 1 ] !== '' && parts[ parts.length - 1 ] !== 'index.html' ) {
			pageURL.slug = parts[ parts.length - 1 ];
		} else {
			pageURL.slug = parts[ parts.length - 2 ];
		}

		if ( pageURL.slug ) {
			if ( pageURL.slug.indexOf( '.' ) !== -1 ) {
				var slugger = pageURL.slug.split( '.' );
				pageURL.name = slugger[ 0 ];
				pageURL.extension = slugger[ 1 ];
			} else {
				pageURL.name = pageURL.slug;
				pageURL.extension = '';
			}
		} else {
			pageURL.slug = '';
			pageURL.name = '';
			pageURL.extension = '';
		}

		if ( parts.length <= 4 && CommonFunctions.constants.LANGUAGES.indexOf( pageURL.slug ) !== -1 ) {
			pageURL.slug = pageURL.country;
		}

		if ( hash ) {
			pageURL.hash = hash;
		}

		if ( parts.length >= 5 ) {
			pageURL.subcategory = parts[ 3 ];
		}

		if ( pageURL.pathname.indexOf( 'priority' ) !== -1 ) {
			pageURL.segment = 'priority';
		} else if ( pageURL.pathname.indexOf( 'business' ) !== -1 ) {
			pageURL.segment = 'business';
		}

		if ( countryMapping[ pageURL.country ] ) {
			pageURL.country = countryMapping[ pageURL.country ];
		}

		return pageURL;
	}

	/**
	 * return cookie value
	 * @param {String} key is the name of the cookie
	 * @return {String} return selected cookie value
	 * @example
	 * getCookie('subChanCode')
	 */
	getCookie( key ) {
		var name = key + '=';
		var decodedCookie = decodeURIComponent( document.cookie );
		var ca = decodedCookie.split( ';' );
		for ( var i = 0; i < ca.length; i++ ) {
			var c = ca[ i ];
			while ( c.charAt( 0 ) === ' ' ) {
				c = c.substring( 1 );
			}
			if ( c.indexOf( name ) === 0 ) {
				return c.substring( name.length, c.length );
			}
		}

		return null;
	}

	getPageContext() {
		let that = this;
		var $title = document.title;
		var $country = document.querySelector( 'meta[name="sc:country"]' );
		var $language = document.querySelector( 'meta[name="sc:language"]' );
		var $segment = document.querySelector( 'meta[name="sc:segment"]' );
		var $category = document.querySelector( 'meta[name="sc:categories"]' );
		var $subcategory = document.querySelector( 'meta[name="sc:subcategories"]' );
		var $slug = document.querySelector( 'meta[name="sc:page-slug"]' );

		var pageContext = {
			title: null,
			country: null,
			language: null,
			segment: null,
			category: null,
			subcategory: null,
			slug: null,
		};

		if ( $title ) {
			pageContext.title = $title.trim();
		}

		if ( $country ) {
			pageContext.country = $country.getAttribute( 'content' );
		}

		if ( $language ) {
			pageContext.language = $language.getAttribute( 'content' );
		}

		if ( ! pageContext.language ) {
			var docLang = document.documentElement.lang;
			if ( docLang ) {
				// Document language can be in languageCode-countryCode format, e.g en-US.
				// In front-end context, we don't need countryCode part
				pageContext.language = docLang.split( '-' )[ 0 ].toLowerCase();
			}
		}

		if ( $segment ) {
			pageContext.segment = $segment.getAttribute( 'content' );
		}

		if ( $category ) {
			pageContext.category = $category.getAttribute( 'content' );
		}

		if ( $subcategory ) {
			pageContext.subcategory = $subcategory.getAttribute( 'content' );
		}

		if ( $slug ) {
			pageContext.slug = $slug.getAttribute( 'content' );
		}

		return that.extend( that.urlBreakdown( window.location.href ), pageContext );
	}

	extend( obj, src ) {
		Object.keys( src ).forEach( function ( key ) {
			obj[ key ] = src[ key ];
		} );
		return obj;
	}

	getPageUrl() {
		return this.getPageContext();
	}

	/**
	 * Get the country code from the URL
	 * @returns {*}
	 */
	getCountryNameFromURL() {
		let that = this;
		var url = window.location.href;
		var removeHTTP = url.replace( 'http://', '' ).replace( 'https://', '' );
		var splitURL = removeHTTP.split( '/' );
		var currentEnvironment = that.getCurrentEnvironment();
		return CommonFunctions.constants.DEVELOPMENT === currentEnvironment ||
			CommonFunctions.constants.STAGING === currentEnvironment
			? splitURL[ 2 ]
			: splitURL[ 1 ];
	}

	getCurrentEnvironment() {
		let that = this;
		var urlObj = [
			'cmsdev',
			'preview',
			'standardchartered',
			'sc',
			'com',
			'av',
			'assets',
			'global',
			'development',
			'staging',
			'digital',
			'https',
			'cmsstage',
			'cms',
			'dev',
			'zoo',
		];
		var domain = that.getPageUrl().domain;
		if ( domain.indexOf( urlObj[ 3 ] + '.' + urlObj[ 4 ] ) !== -1 ) {
			if ( domain === urlObj[ 0 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
				return CommonFunctions.constants.DEVELOPMENT;
			} else if ( domain === urlObj[ 12 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
				return CommonFunctions.constants.STAGING;
			} else if ( domain === urlObj[ 13 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
				return CommonFunctions.constants.PREVIEW;
			} else {
				return CommonFunctions.constants.PRODUCTION;
			}
		} else if ( domain === urlObj[ 1 ] + '.' + urlObj[ 2 ] + '.' + urlObj[ 4 ] ) {
			if ( that.getPageUrl().pathname.match( '^/staging' ) ) {
				return CommonFunctions.constants.STAGING;
			} else if ( that.getPageUrl().pathname.match( '^/development' ) ) {
				return CommonFunctions.constants.DEVELOPMENT;
			} else {
				return CommonFunctions.constants.PREVIEW;
			}
		} else {
			return CommonFunctions.constants.DEVELOPMENT;
		}
	}

	previewLog( log ) {
		let that = this;
		if (
			that.getCurrentEnvironment() === CommonFunctions.constants.PREVIEW ||
			that.getCurrentEnvironment() === CommonFunctions.constants.DEVELOPMENT
		) {
			/* eslint-disable no-console */
			if ( typeof console !== 'undefined' && typeof console.log !== 'undefined' ) {
				console.log( log );
			}
			/* eslint-enable no-console */
		}
	}
}

const instance = new CommonFunctions();

export default instance;
